<template>
    <div class="home">
        <b-img src="images/apple.png" fluid />
        <b-row>
            <b-col cols="auto" class="ml-auto mr-4" style="font-size: smaller;">Bildquelle: AdobeStock</b-col>
        </b-row>
        <span v-html="$t('presentation.team')" />
        <b-card-group deck>
            <b-card title="RSM Ebner Stolz" style="max-width: 300px;">
                <b-col sm>
                    <img src="images/team/CatalinaSahlmann.png" height="200" class="text-middle mt-4">
                </b-col>
                <br/>
                <p class="card-text">
                    
                    <strong>Catalina Sahlmann</strong> 
                    <br/>
                    <a href="mailto: catalina.sahlmann@ebnerstolz.de">catalina.sahlmann@ebnerstolz.de</a><br/>
                    <br />
                    Tel. +49 40 37097-193
                    <br/>
                    <br/>
                </p>
            </b-card>
        </b-card-group>
        <br/>
        <br/>
        <br/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'team',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>